import { useContext } from 'react';
import { AuthUserContext } from '../contexts/authUserContext';

/**
 * Interact with the Auth User Context
 */
export const useAuthUser = () => {
  const { authUser, isError, hasCapability, hasService } =
    useContext(AuthUserContext);
  return {
    authUser,
    isError,
    hasCapability,
    hasService,
  };
};
